import { Drawer } from 'dingtalk-design-mobile'
import './AddressModal.less'
import { useCallback, useEffect, useRef, useState } from 'react'
import { _getArea } from '@/api/user'


const AddressModal = ({ show = false, onClose, initialValues, }) => {
  const areaMapLong = ['省份/地区', '城市', '区/县', '街道']
  const areaMapShort = ['省份/地区', '城市', '区/县']
  const [areaMap, setAreaMap] = useState(areaMapLong)
  const [selectArea, setSelectArea] = useState([])
  const [areaList, setAreaList] = useState([[], [], [], []])
  const [areaIndex, setAreaIndex] = useState(0)
  
  const getArea = (id = 1, index = 0) => {
    return new Promise(resolve => {
      _getArea({parentId: id}).then(([success, res]) => {
        if (success) {
          setAreaList(pre => {
            pre[index] = res.addresses
            return [...pre]
          })
          resolve(res.addresses || [])
        }
      })
    })
  }

  const handleSelect = useCallback(async (item) => {
    setSelectArea(pre => {
      pre[areaIndex] = item
      return [...pre]
    })
    if ( areaIndex < 3) {
      const res = await getArea(item.code, areaIndex + 1)
      if (res.length > 0) {
        setAreaIndex(pre => pre + 1)
        if (areaIndex === 2) {
          setAreaMap(areaMapLong)
        }
      }else {
        setAreaMap(areaMapShort)
        onClose(selectArea)
      }
    }else {
      onClose(selectArea)
    }
  }, [selectArea, areaIndex, areaMap])

  const handleReselect = useCallback((i) => {
    if (i > 3 || selectArea.length <= i) return
    setAreaIndex(i)
    setSelectArea(pre => {
      pre.length = i + 1
      return [...pre]
    })
  }, [areaIndex, selectArea])

  useEffect(async() => {
    setSelectArea(initialValues)
    setAreaIndex(initialValues.length)
    await getArea()
    if (initialValues.length !== 0) {
      initialValues.map(async(item, index) => await getArea(item.code, index + 1))
    }
  }, [])

  return (
    <Drawer
      size="large"
      title='请选择所在地区'
      visible={show}
      onVisibleChange={() => onClose(initialValues)}
      className='com-address'
      topBordered={null}
    >
      <div className='com-address--header'>
        <div className='header--container'>
          {
            areaMap.map((item, index) => {
              return (
                selectArea.length >= index ? 
                <div 
                  key={index} 
                  onClick={() => handleReselect(index)}
                >{ selectArea[index] ? selectArea[index].name : item }</div>
                : null
              )
            })
          }
        </div>
      </div>
      <div className='com-address-list--container'>
        {
          areaList[areaIndex].map(item => {
            return <div 
              key={item.code} 
              className={
                (selectArea[areaIndex] && item.code === selectArea[areaIndex].code) ? 'list-item active' : 'list-item'
              }
              onClick={() => handleSelect(item)}
            >{ item.name }</div>
          })
        }
      </div>
    </Drawer>
  )
}

export default AddressModal